import rawRoutes from '@/router/routes'
import ADMRoute from '@/models/dynamic-routes/adm-route.model'
import { DinamicRouteParams } from '@/interfaces/dynamic-routes-params.interface'

function createDinamicRoute (routeParams: DinamicRouteParams) {
    let route
    const { path, name, parentName, meta } = routeParams
    switch (routeParams.type) {
    case 'ADM':
        route = new ADMRoute({ path, name, parentName, meta })
        break
    }
    return route
}

const routes = rawRoutes.map((routeParams) => {
    return createDinamicRoute(routeParams as DinamicRouteParams)
})

export default routes
